import { ESipayceCardPaymentStatus } from '../configurations/order-status';

export class SipayceCardPaymentUtils {
  /**
   * Checks if the payment is successful.
   *
   * @param paymentStatus {string}
   * @return {boolean}
   */
  static isPaymentSuccessful(paymentStatus: string | null | undefined): boolean {
    return [
      ESipayceCardPaymentStatus.FINISHED,
      ESipayceCardPaymentStatus.OK,
    ].includes(paymentStatus as ESipayceCardPaymentStatus);
  }

  /**
   * Checks if the payment is failed.
   *
   * @param paymentStatus {string}
   * @return {boolean}
   */
  static isPaymentFailed(paymentStatus: string | null | undefined): boolean {
    return paymentStatus === ESipayceCardPaymentStatus.ERROR;
  }

  /**
   * Checks if the payment is aborted.
   *
   * @param paymentStatus {string}
   * @return {boolean}
   */
  static isPaymentAborted(paymentStatus: string | null | undefined): boolean {
    return paymentStatus === ESipayceCardPaymentStatus.ABORTED;
  }
}
